module.exports = __webpack_public_path__ + "assets/aaa698b69595e13dae0cd2674ca80023.png";